import { Server, Clock } from 'lucide-react';

import { fmt, fmtRelative } from '../utils/format';

// Single-line worker health strip. Green pill when all expected workers are
// active, orange when short-staffed.
export const WorkersStrip = ({ workers = {} }) => {
  const expected = workers.expected ?? 0;
  const seen = workers.seen_recently ?? 0;
  const healthy = expected > 0 && seen >= expected;
  const tone = healthy ? 'text-greenColor' : 'text-orangeColor';
  const bg = healthy ? 'bg-greenColor/10' : 'bg-orangeColor/10';

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-gray-200 p-3 bg-white hover:shadow-sm transition-all duration-200">
      <div className="flex items-center gap-2.5">
        <span
          className={`flex items-center justify-center w-8 h-8 rounded ${bg} ${tone}`}
        >
          <Server size={16} />
        </span>
        <div className="flex flex-col leading-tight">
          <span className="text-[10px] uppercase tracking-wider text-darkGrayColor">
            Workers
          </span>
          <span className={`text-sm font-semibold ${tone}`}>
            {fmt(seen)} of {fmt(expected)} active
          </span>
        </div>
      </div>
      {workers.last_processed_at && (
        <div className="flex items-center gap-1.5 text-[11px] text-darkGrayColor">
          <Clock size={12} />
          <span>
            Last job processed {fmtRelative(workers.last_processed_at)} ago
          </span>
        </div>
      )}
    </div>
  );
};
